import { combineReducers } from 'redux';
import { operationError, showProgress } from "../common/errorhandler/reducers/reducers";
import { localeReducer } from '../common/localeprovider/reducers';
import { reducer as reduxFormReducer } from 'redux-form';
import { GetEventLogsReducers } from '../MSVPages/EventLogs/reducers';
import { GetGeneratedMessageReducers } from '../MSVPages/GeneratedMessage/reducers';

export default combineReducers({
    showProgress,
    operationError,
    localeReducer,
    form: reduxFormReducer,
    GetEventLogsReducers,
    GetGeneratedMessageReducers
});